export enum EActionTypes {
  SET_FORM_DATA = 'formData/setData',
  SET_FORM_DATA_ERROR = 'formData/setError',
}
